import {
  ComponentAction,
  RunComponentActionResponse,
} from '@cast/types-cluster-management';

export const generateClusterManagementRunAction = (
  mockAction: Partial<ComponentAction> = {}
): RunComponentActionResponse => {
  return {
    action: {
      action: 'UPDATE',
      automated: false,
      description:
        'Update action will perform migration of the component from the used version to the latest available version.',
      script: `resource "castai_workload_scaling_policy" "services" {
  name              = "services"
}`,
      ...mockAction,
    },
  };
};
